import { put } from "redux-saga/effects";
import { pendingTask, begin, end } from "react-redux-spinner";

import {
  getApiKeysResponse,
  ICreateNewApiKey, IDeleteApiKey,
  IEditApiKey,
  userUpdateResponse
} from "../user.actions";
import UserService from "../user.service";
import UserFeedback from "../user.feedback";
import {IApiKey, IUser} from "@common/models";

export function* getApiKeys() {
  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const service = new UserService();
    const apiKeys = yield service.getApiKeys();
    yield put(getApiKeysResponse(apiKeys));
  } catch (error) {
    yield put(getApiKeysResponse(error, UserFeedback.API_KEY_GET_FAILED));
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* editApiKeySaga(action: IEditApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const service = new UserService();
    const { apiKey, newName } = action.payload;
    const user = yield service.editApiKey(apiKey.tokenName, newName);
    yield put(userUpdateResponse(user, UserFeedback.API_KEY_EDIT_UPDATED));
  } catch (error) {
    yield put(userUpdateResponse(error, UserFeedback.API_KEY_EDIT_FAILED));
  }
  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* createNewApiKeySaga(action: ICreateNewApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const service = new UserService();
    const { userId } = action.payload;
    const user: IUser = yield service.createNewApiKey(userId);

    yield put(
      userUpdateResponse(user, UserFeedback.CREATE_NEW_API_KEY_SUCCESS)
    );
  } catch (error) {
    yield put(
      userUpdateResponse(error, UserFeedback.CREATE_NEW_API_KEY_FAILED)
    );
  }
  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* deleteApiKeySaga(action: IDeleteApiKey) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const service = new UserService();
    const { userId, apiKeyName } = action.payload;
    const user: IUser = yield service.deleteApiKey(userId, apiKeyName);

    yield put(userUpdateResponse(user, UserFeedback.DELETE_API_KEY_SUCCESS))
  } catch (error) {
    yield put(userUpdateResponse(error, UserFeedback.DELETE_API_KEY_FAILED))
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}
